import { useLackGames, useLackTourneys } from "@/src/hooks/data/useLobby";
import useMasterGameDefinitions from "@/src/hooks/data/useMasterGameDefinitions";
import { handleRemoveDisplayedCashLackGame } from "@/Poker/redux/slices/lobbySlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useCreateGame from "@/src/hooks/utils/useCreateGame";

export default function GameServiceProvider({ children }) {
    const dispatch = useDispatch();
    const [isLackGamesDisplayed, setIsLackGamesDisplayed] = useState(false);
    const [isLackTourneyGamesDisplayed, setIsLackTourneyGamesDisplayed] = useState(false);
    const lackGames = useLackGames();
    const lackTourneys = useLackTourneys();
    const { createLackTable, createTourneyLackTable } = useCreateGame();
    const masterGameDefinitions = useMasterGameDefinitions();
    const privateTableActiveGameDefinitions = useSelector((state) => state.lobby.privateTable.lobbyData.activeTables);
    const masterTourneysData = useSelector(
        (state) => state.lobby.masterTourneysData
    );

    const processLackGames = (lackGamesDetails) => {
        setIsLackGamesDisplayed(true);

        const lackGamesDefinitions = lackGamesDetails.filter((eachGameDef) => {
            if (
                (eachGameDef.isPrivateTable &&
                    privateTableActiveGameDefinitions.hasOwnProperty(
                        eachGameDef.gameDefId
                    )) ||
                masterGameDefinitions.hasOwnProperty(eachGameDef.gameDefId)
            ) {
                return eachGameDef;
            }
            return false;
        });

        lackGamesDefinitions.forEach((eachGameDefinition) => {
            let currentLackGame = eachGameDefinition;
            if (currentLackGame?.nodeIp) {
                createLackTable(currentLackGame, masterGameDefinitions, privateTableActiveGameDefinitions);
                dispatch(
                    handleRemoveDisplayedCashLackGame({
                        roomId: currentLackGame.gameDefId,
                    })
                );
            }
        });
    };

    const processTourneyLackGames = (lackTourneyGameDetails) => {
        setIsLackTourneyGamesDisplayed(true);
        lackTourneyGameDetails?.forEach((eachTourney) => {
            if (eachTourney?.gameDefinition?.blindStructure) {
                createTourneyLackTable(eachTourney, masterTourneysData);
            }
        })
    }

    useEffect(() => {
        if (lackGames?.length > 0 && !isLackGamesDisplayed) {
            processLackGames(lackGames)
        }

        if (lackTourneys?.length > 0 && !isLackTourneyGamesDisplayed) {
            processTourneyLackGames(lackTourneys)
        }
    }, [lackGames, lackTourneys])

    return children
}
